import { ACLType } from 'modules/authorization';

import { AppRoute } from '../models';
import { lazyNamed } from 'utils';

const authenticatedRoutes: AppRoute[] = [
  {
    key: 'dashboard',
    title: 'Dashboard',
    path: '/dashboard',
    access: ACLType.Authenticated,
    Element: lazyNamed(() => import('views/Dashboard'), 'Dashboard'),
  },
  {
    key: 'events',
    title: 'Events',
    path: '/events',
    access: ACLType.Authenticated,
    Element: lazyNamed(() => import('views/Events'), 'Events'),
  },
  {
    key: 'event-details',
    access: ACLType.Authenticated,
    Element: lazyNamed(() => import('views/EventDetails'), 'EventDetails'),
    title: 'Event details',
    path: '/events/:id',
  },
  {
    key: 'events-history',
    title: 'Events history',
    path: '/events-history',
    access: ACLType.Authenticated,
    Element: lazyNamed(() => import('views/Events'), 'Events'),
  },
  {
    title: 'Event history details',
    path: '/events-history/:id',
    key: 'event-history-details',
    access: ACLType.Authenticated,
    Element: lazyNamed(() => import('views/EventDetails'), 'EventDetails'),
  },
  {
    key: 'buy-tickets',
    title: 'Buy tickets',
    path: '/buy-tickets/:id',
    access: ACLType.Authenticated,
    Element: lazyNamed(() => import('views/BuyTickets'), 'BuyTickets'),
  },
  {
    key: 'payment-success',
    title: 'Payment success',
    path: '/payment-success',
    access: ACLType.Authenticated,
    Element: lazyNamed(() => import('views/PaymentSuccess'), 'PaymentSuccess'),
  },
  {
    key: 'payment-failure',
    title: 'Payment failure',
    path: '/payment-failure',
    access: ACLType.Authenticated,
    Element: lazyNamed(() => import('views/PaymentFailure'), 'PaymentFailure'),
  },
  {
    key: 'videos',
    access: ACLType.Authenticated,
    Element: lazyNamed(() => import('views/VideoCategories'), 'VideoCategories'),
    title: 'Videos',
    path: '/videos/*',
  },
  {
    key: 'video-category-details',
    access: ACLType.Authenticated,
    Element: lazyNamed(() => import('views/Videos'), 'Videos'),
    title: 'Video category details',
    path: '/videos/:categoryName/*',
  },
  {
    key: 'video-details',
    access: ACLType.Authenticated,
    Element: lazyNamed(() => import('views/VideoDetails'), 'VideoDetails'),
    title: 'Video details',
    path: '/videos/:categoryName/:id',
  },
  {
    key: 'audios',
    access: ACLType.Authenticated,
    Element: lazyNamed(() => import('views/AudioCategories'), 'AudioCategories'),
    title: 'Audios',
    path: '/audios',
  },
  {
    key: 'audio-category-details',
    access: ACLType.Authenticated,
    Element: lazyNamed(() => import('views/Audios'), 'Audios'),
    title: 'Audio category details',
    path: '/audios/:categoryName',
  },
  {
    key: 'audio-details',
    access: ACLType.Authenticated,
    Element: lazyNamed(() => import('views/AudioDetails'), 'AudioDetails'),
    title: 'Audio details',
    path: '/audios/:categoryName/:id',
  },
  {
    key: 'team',
    access: ACLType.TeamLeadersAndAdmin,
    Element: lazyNamed(() => import('views/Team'), 'Team'),
    title: 'Team details',
    path: '/team/:id?/*',
  },
  {
    key: 'team-members',
    access: ACLType.TeamLeadersAndAdmin,
    Element: lazyNamed(() => import('views/TeamMembers'), 'TeamMembers'),
    title: 'Team details',
    path: '/team/:id/members',
  },
  {
    key: 'audio-playlists',
    access: ACLType.Authenticated,
    Element: lazyNamed(() => import('views/AudioPlaylists'), 'AudioPlaylists'),
    title: 'Playlists',
    path: '/audio-playlists',
  },
  {
    key: 'audio-playlists-details',
    access: ACLType.Authenticated,
    Element: lazyNamed(() => import('views/AudioPlaylists'), 'AudioPlaylists'),
    title: 'Audio Playlist',
    path: '/audio-playlists/:playlist',
  },
  {
    key: 'audio-playlists-item',
    access: ACLType.Authenticated,
    Element: lazyNamed(() => import('views/AudioDetails'), 'AudioDetails'),
    title: 'Audio Playlist Details',
    path: '/audio-playlists/:playlist/:id',
  },
  {
    key: 'video-playlists',
    access: ACLType.Authenticated,
    Element: lazyNamed(() => import('views/VideoPlaylists'), 'VideoPlaylists'),
    title: 'Playlists',
    path: '/video-playlists',
  },
  {
    key: 'video-playlists-details',
    access: ACLType.Authenticated,
    Element: lazyNamed(() => import('views/VideoPlaylists'), 'VideoPlaylists'),
    title: 'Video Playlists',
    path: '/video-playlists/:playlist',
  },
  {
    key: 'video-playlists-item',
    access: ACLType.Authenticated,
    Element: lazyNamed(() => import('views/VideoDetails'), 'VideoDetails'),
    title: 'Video Playlist Details',
    path: '/video-playlists/:playlist/:id',
  },
  {
    key: 'tickets-overview',
    access: ACLType.Authenticated,
    Element: lazyNamed(() => import('views/DashboardTicketOverview'), 'DashboardTicketOverview'),
    title: 'Your tickets',
    path: '/tickets',
  },
  {
    key: 'tickets',
    access: ACLType.Authenticated,
    Element: lazyNamed(() => import('views/DashboardTicketDetails'), 'DashboardTicketDetails'),
    title: 'Event tickets',
    path: '/tickets/:id',
  },
  {
    key: 'shared-items',
    access: ACLType.Authenticated,
    Element: lazyNamed(() => import('views/SharedItems'), 'SharedItems'),
    title: 'Shared items',
    path: '/shared-items',
  },
  {
    key: 'profile',
    access: ACLType.Authenticated,
    Element: lazyNamed(() => import('views/Profile'), 'Profile'),
    title: 'User Profile',
    path: '/profile',
  },
  {
    key: 'subscription',
    access: ACLType.Authenticated,
    Element: lazyNamed(() => import('views/Subscription'), 'Subscription'),

    title: 'Subscription',
    path: '/subscription',
  },
  {
    key: 'subscription-success',
    access: ACLType.Authenticated,
    Element: lazyNamed(() => import('views/SubscriptionSuccess'), 'SubscriptionSuccess'),

    title: 'Subscription',
    path: '/subscription-success',
  },
  {
    key: 'event-stats',
    access: ACLType.TeamLeadersAndAdmin,
    Element: lazyNamed(() => import('views/EventStatsList'), 'EventStatsList'),
    title: 'Event stats',
    path: '/event-stats',
  },
  {
    key: 'event-stats-details',
    access: ACLType.TeamLeadersAndAdmin,
    Element: lazyNamed(() => import('views/EventStatsOverview'), 'EventStatsOverview'),
    title: 'Event stats',
    path: '/event-stats/:id',
  },
  {
    key: 'member-profile',
    access: ACLType.TeamLeadersAndAdmin,
    Element: lazyNamed(() => import('views/DashboardMemberDetails'), 'DashboardMemberDetails'),
    title: 'Member profile',
    path: '/member-profile/:memberId',
  },
  {
    key: 'users-list',
    access: ACLType.AdministratorOnly,
    Element: lazyNamed(() => import('views/DashboardUsers'), 'DashboardUsers'),
    title: 'Users list',
    path: '/users',
  },
  {
    key: 'subscription-management',
    access: ACLType.Authenticated,
    Element: lazyNamed(() => import('views/SubscriptionManagement'), 'SubscriptionManagement'),
    title: 'Subscription management',
    path: '/manage-subscription',
  },
  {
    key: 'dashboard-reports',
    access: ACLType.AdministratorOnly,
    Element: lazyNamed(() => import('views/dashboard-reports/DashboardReports'), 'DashboardReports'),
    title: 'Reports',
    path: '/reports',
  },
  {
    key: 'unassigned-users-reports',
    access: ACLType.AdministratorOnly,
    Element: lazyNamed(() => import('views/dashboard-reports/UnassigedUsersReports'), 'UnassignedUsersReports'),
    title: 'Unassigned users reports',
    path: '/reports/unassigned-users',
  },
];

export default authenticatedRoutes;
